import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from '@material-ui/icons/Close';
import { withStyles, Grid } from "@material-ui/core";
import Dialog from "../../../../components/Dialog/Dialog";
import MensagemWhatsappIcon from "../../../../components/Icon/MensagemWhatsappIcon";

const styles = theme => ({
    alertContainer: {
        width: 304,
        height: 175,
        overflow:"hidden",
    },
    alertTitle: {
        "& h6": {
            fontSize: 19,
            fontStyle: 'normal',
            fontWeight: 'bold',
        },
        width: '100%'
    },
    button: {
        position: 'absolute',
        right: 20,
        top: 20
    },
    buttonWhatsApp:{
        background:"transparent",
        color:"#868686",
    },
    contentButton:{
        color:"#868686",
        fontSize:"12px",
        display:"flex",
        flexDirection: "column",
        alignItems:"flex-start",
        justifyContent:"center"
    },
    text:{
        padding:"5px",
        textWrap:"nowrap",
        fontSize:"13px",
        fontWeight:"600"
    },
    contentButtonWhatsApp:{
        display:"flex",
        flexDirection:"column",
        background:"#F2F2F2",
        border:"1px solid #0000001A",
        width:"calc(100% - 65px);",
        height:"60px",
        padding:"0px 8px ",
        borderRadius:"8px",
        alignItems:"center",
        fontWeight:"500",
        cursor:"pointer"
    },
    iconClose:{
        cursor:"pointer",
    },
    paper:{
        overflow:"hidden"
    }
});

const ModalCompartilhar = ({
    open,
    onClose,
    classes,
    onClick,
}) => (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{paper:classes.paper}}
        >
            <div className={classes.alertContainer}>
                <DialogTitle className={classes.alertTitle}>
                    <Grid>
                    <div style={{fontSize: 18, color:"#505050"}} c>
                           Compartilhar
                        </div>
                        <div className={classes.button}>
                                <CloseIcon id="prt-mcp-ico-cls" className={classes.iconClose} fontSize={'small'} onClick={onClose}/>
                        </div>
                    </Grid>
                        <div className={classes.contentButton}>
                            <div className={classes.text}>Enviar arquivo via Whatsapp</div>
                            <div id="prt-mcp-div-wpp" className={classes.contentButtonWhatsApp} onClick={onClick}>
                                  <MensagemWhatsappIcon width={"25px"}/>
                                  WhatsApp                                 
                            </div>
                            
                        </div>
                </DialogTitle>
            </div>
        </Dialog>
    );

export default withStyles(styles)(ModalCompartilhar);
